import {
  RailsItem,
  RailsThumbnailItem,
} from '@sls-react/typings/services/rails/item';
import { RailsSale } from '@sls-react/typings/services/rails/sales';
import categoryAnalytics from '@sls-react/services/analytics/catagoryAnalytics';

interface ItemAnalytics {
  category?: string;
  category_1?: string;
  category_2?: string;
  category_3?: string;
  item_id: number;
  list_price: number;
  sale?: string;
}

export default function buildItemAnalytics(
  item: RailsItem | RailsThumbnailItem,
  sale: null | string | RailsSale = null,
): ItemAnalytics {
  const itemAnalytics: ItemAnalytics = {
    ...('categories' in item && categoryAnalytics(item.categories)),
    category: 'categories' in item ? item.categories?.[0]?.slug : undefined,
    item_id: item.id,
    list_price: item.price,
  };

  if ('sale' in item && sale) {
    itemAnalytics.sale = typeof sale === 'string' ? sale : sale.slug;
  }

  return itemAnalytics;
}
